import { Link, NavLink } from "react-router-dom";
import { useState, useEffect } from 'react';
import "./Navbar.css";

const Navbar = () => {
  const [showNavbar, setShowNavbar] = useState(false);

  const handleShowNavbar = () => {
    setShowNavbar(!showNavbar);
  };

  const hideNavBar = () => {
    const ham = document.getElementById("hamburger");
    if (showNavbar) {
      ham.checked = false;
      setShowNavbar(false);
    }
  };

  useEffect(() => {
    if (showNavbar) {
      document.body.style.overflow = 'hidden'; 
    } else {
      document.body.style.overflow = 'auto'; 
    }

    return () => {
      document.body.style.overflow = 'auto'; 
    };
  }, [showNavbar]);

  return (
    <nav className="navbar">
      <div className="banner">
        <h1>Výroba, predaj a servis sedacích súprav s viac ako 30-ročnou tradíciou</h1>
      </div>
      <div className="container">
        <div className="logo">
          <Link to="/" onClick={hideNavBar}><img width="112.94" height="40" src="/data/photos/logo/interstyle-logo.svg" alt="logo" /></Link>
        </div>
        <input type="checkbox" id="hamburger"></input>
        <label htmlFor="hamburger" className="menu-icon" onClick={handleShowNavbar}>
          <span></span>
          <span></span>
          <span></span>
        </label>
        <div className={`overlay ${showNavbar && 'active'}`}></div>
        <div className={`nav-elements ${showNavbar && 'active'}`}>
          <ul>
            <li>
              <NavLink to="/Onas" onClick={hideNavBar}>O nás</NavLink>
            </li>
            <li>
              <NavLink to="/Sedacky" onClick={hideNavBar} >Sedačky</NavLink>
            </li>
            <li>
              <NavLink to="/Postele" onClick={hideNavBar} >Postele</NavLink>
            </li>
            <li>
              <NavLink to="/Stoly-a-stolicky" onClick={hideNavBar} >Stoličky</NavLink>
            </li>
            <li>
              <NavLink to="/Ihned-k-odberu" onClick={hideNavBar} >Skladom</NavLink>
            </li>
            <li>
              <NavLink to="/Kontakt" onClick={hideNavBar} >Kontakt</NavLink>
            </li>
          </ul>
        </div>
        <div className={`nav-socials ${showNavbar && 'active'}`}>
          <ul>
            <li>
              <a
                href="https://www.facebook.com/yourpage"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/data/photos/logo/facebook.png"
                  alt="Facebook"
                  style={{ width: '32px', height: '32px' }}
                />
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/yourprofile"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/data/photos/logo/instagram.png"
                  alt="Instagram"
                  style={{ width: '32px', height: '32px' }}
                />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
